module.exports = __webpack_public_path__ + "static/media/gb1.142db584.png";